/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Site} from "../../model/Site";
import {SitesService} from "../../services/sites.service";
import {NgxSpinnerService} from 'ngx-spinner';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-sites',
    templateUrl: './sites.component.html',
    styleUrls: ['./sites.component.less'],
    standalone: false
})
export class SitesComponent extends BaseMessageComponent implements OnInit {
  sites: Site[];
  indexWithChanges: number[] = [];

  constructor(private sitesService: SitesService,
              private spinnerService: NgxSpinnerService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getSites();
  }

  getSites(): void {
    this.spinnerService.show();
    this.sites = [];
    this.indexWithChanges = [];
    this.sitesService.getAllSites().subscribe( value => {
      this.sites = value;
      this.cdr.detectChanges();
      },
      err => {
      console.log(err);
      alert(err);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
    }
    );
  }

  addNew(name: string, code: string) {
    if (name.trim() == "") {
      alert("Please add a name and code before saving a new record.");
    } else {
      this.spinnerService.show();
      var newSite = new Site();
      newSite.siteName = name;
      newSite.siteCode = code;
      newSite.isActive = true;

      this.sitesService.addNew(newSite).subscribe(value => {
          //success
          this.sites = null;
          this.getSites();
        }, (error) => {
          //failed
          console.error(error);
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
  }

  updateSitesIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  saveChanges() {
    this.spinnerService.show();
    if(this.indexWithChanges.length > 0) {
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        this.sitesService.updateSite(this.sites[idx]).subscribe(value => {
            console.log(this.sites[idx] + " saved.")
          }, (error) => {
            //failed
            this.spinnerService.hide();
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
          },
          () => {
            this.spinnerService.hide();
            this.indexWithChanges = [];
          });
      }
      setTimeout(() => {
        this.getSites();
      }, 4000);
    } else {
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }
}
